'use client';

import { XIcon } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Drawer, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from '@/components/ui/drawer';

export const DrawerWrapper = ({
  trigger,
  children,
  title,
}: {
  trigger: React.ReactNode;
  children: React.ReactNode;
  title: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Drawer
      shouldScaleBackground
      open={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <DrawerTrigger
        asChild
        onClick={() => setIsOpen(true)}
      >
        {trigger}
      </DrawerTrigger>
      <DrawerContent
        className='flex min-h-[30%] w-full flex-col rounded-t-2xl p-0'
        onInteractOutside={() => setIsOpen(false)}
      >
        <div className='flex w-full max-w-5xl grow flex-col pt-4'>
          <DrawerHeader className='flex items-center justify-between gap-4 border-b px-4 pb-5'>
            <div className='flex flex-col gap-0'>
              <DrawerTitle className='text-left text-base'>{title}</DrawerTitle>
            </div>
            <DrawerClose asChild>
              <Button
                variant={'secondary'}
                size={'icon'}
                aria-label='Stäng'
                className='rounded-full'
                onClick={() => setIsOpen(false)}
              >
                <XIcon size={14} />
              </Button>
            </DrawerClose>
          </DrawerHeader>
          <div className='flex flex-col'>{children}</div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
